import { Box, Flex, Heading, IconButton, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import "../App.css";
import { BellIcon } from "@chakra-ui/icons";
import moment from "moment";
import { useSelector } from "react-redux";

function Header() {
  const user = useSelector((state) => state?.auth?.userProfile);
  const styles = {
    title: {
      fontSize: { base: "larger", md: "x-large" },
      fontWeight: 700,
      fontFamily: "'Barlow', sans-serif",
      fontStyle: "normal",
      textTransform: "uppercase",
    },
    header: {
      paddingLeft: "30px",
      paddingRight: "30px",
      height: "10vh",
      justifyContent: "space-between",
      alignItems: "center",
    },
    notificationButton: {
      colorScheme: "green",
      fontSize: { base: "20px", md: "22px" },
      isRound: true,
    },
    userName: {
      paddingRight: 6,
      flexDirection: "row",
      textAlign: "center",
    },
    profileContainer: {
      flexDirection: "column",
      paddingRight: 8,
      alignItems: "flex-start",
    },
  };

  const [currentTime, setCurrentTime] = useState(
    moment().format("YYYY-MM-DD HH:mm:ss"),
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(moment().format("DD MMMM YYYY - HH:mm:ss"));
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Flex {...styles.header}>
      <Box>
        <Text {...styles.title}>{user?.organization}</Text>
      </Box>
      <Flex {...styles.userName}>
        <Flex {...styles.profileContainer}>
          <Heading
            size={"sm"}
            fontWeight={600}
            fontFamily="'Barlow', sans-serif"
            fontStyle="normal"
            textTransform="uppercase">
            {user?.first_name
              ? user?.first_name + " " + user?.last_name
              : "User"}
          </Heading>
          <Text fontSize={13} fontFamily="'Barlow', sans-serif">
            {currentTime}
            {/* {" "}
            type : {user?.user_type} | {currentTime} */}
          </Text>
        </Flex>

        <IconButton icon={<BellIcon />} {...styles.notificationButton} />
      </Flex>
    </Flex>
  );
}

export default Header;
